(function($) {
	function updateScrollbarClass() {
		var hasScrollbar = window.innerWidth > document.documentElement.clientWidth;
		$('#navbar-toggler .hamburger').toggleClass('has-scrollbar', hasScrollbar);
	}

	function setScrollbarWidth() {
		var width = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty('--scrollbar-width', width + 'px');
	}

	function closeMobileMenu() {
		$('body').removeClass('mobile-open');
		$('#navbar-toggler .hamburger').removeClass('is-active');
		$('#mainNav').removeClass('show').attr('aria-hidden', 'true');
		$('#navbar-toggler').attr('aria-expanded', 'false').css('margin-right', '0');
	}

	updateScrollbarClass();
	setScrollbarWidth();

	$(window).on('resize', function() {
		updateScrollbarClass();
		setScrollbarWidth();
	});

	$(document).on('click', '#navbar-toggler', function() {
		var isOpen = $('body').toggleClass('mobile-open').hasClass('mobile-open');
		$(this).find('.hamburger').toggleClass('is-active', isOpen);
		$('#mainNav').toggleClass('show', isOpen).attr('aria-hidden', String(!isOpen));
		$(this).attr('aria-expanded', String(isOpen));

		if (isOpen) {
			$(this).css(
				'padding-right',
				'calc(clamp(1rem, 5vw + 1rem, 4rem) + var(--scrollbar-width))');
		} else {
			$(this).css(
				'padding-right',
				'clamp(1rem, 5vw + 1rem, 4rem)');
		}

	});

	$('.navbar-nav').on('click', 'a', function() {
		closeMobileMenu();
	});

	$(document).on('keydown', function(e) {
		if (e.key === 'Escape' && $('body').hasClass('mobile-open')) {
			closeMobileMenu();
		}
	});

	$(document).on('click', '.navbar-collapse.show', function(e) {
		if (e.target === this) {
			closeMobileMenu();
		}
	});

	$(function() {
		$('#navbar-toggler').attr({ 'aria-expanded': 'false', 'aria-controls': 'mainNav', 'aria-label': 'Navigation umschalten' });
		$('#mainNav').attr('aria-hidden', 'true');
		updateScrollbarClass();
		setScrollbarWidth();
	});

	function adjustInfoBoxes() {
		document.querySelectorAll('.header-info-box').forEach(infoBox => {
			// Reset auf Default
			infoBox.style.left = "0";
			infoBox.style.right = "auto";
			infoBox.style.transform = "translateX(0)";

			const rect = infoBox.getBoundingClientRect();
			if (rect.right > window.innerWidth) {
				// Sobald rechter Rand anstößt → Box nach links schieben
				const overflow = rect.right - window.innerWidth;
				infoBox.style.transform = `translateX(-${overflow + 16}px)`; // +8px Abstand
			}
		});
	}

	window.addEventListener("load", adjustInfoBoxes);
	window.addEventListener("resize", adjustInfoBoxes);
	function markOverflowByCount()
	{
		var collapse = document.querySelector('.collapse.navbar-collapse#mainNav');
		if (!collapse) { return; }
		var nav = collapse.querySelector('.navbar-nav');
		if (!nav) { return; }

		var items = nav.querySelectorAll(':scope > li');
		collapse.classList.remove('has-overflow');

		if (items.length > 7) {
			collapse.classList.add('has-overflow');
			items.forEach(function(el, idx){
				if (idx >= 7) {
					el.classList.add('is-overflow');
				} else {
					el.classList.remove('is-overflow');
				}
			});
		} else {
			items.forEach(function(el){ el.classList.remove('is-overflow'); });
		}
	}

	$(window).scroll(function() {
		if ($(this).scrollTop() > 500) {
			$('.scroll-top-btn').css('opacity', '1');
		}else{
			$('.scroll-top-btn').css('opacity', '0');
		}
	});

	function checkHeaderPosition() {
		let scrollTop = $(window).scrollTop();

		// Breakpoint prüfen (lg = 992px in Bootstrap)
		if (window.innerWidth >= 992) {
			if (scrollTop >= 55) {
				$('.header-top').addClass("scrolled");
			} else {
				$('.header-top').removeClass("scrolled");
			}
		} else {
			// Falls du sicherstellen willst, dass unterhalb von lg keine Klasse hängt:
			$('.header-top').removeClass("scrolled");
		}
	}

	checkHeaderPosition();
	$(document).ready(checkHeaderPosition);
	$(document).scroll(checkHeaderPosition);
	$(window).resize(checkHeaderPosition);


	window.addEventListener('load', markOverflowByCount);
	window.addEventListener('resize', markOverflowByCount);
})(jQuery);
